











import { Component, Vue } from 'vue-property-decorator'
import PreviewWidget from '@/components/widget-dashboard/composables/Preview.vue'
import ListWidgetSetting from '@/components/widget-dashboard/composables/ListWidgetSetting.vue'
import UnitModel from '@/_models/UnitModel'

@Component({
  components: {
    PreviewWidget,
    ListWidgetSetting
  }
})
export default class WidgetDashboardSetting extends Vue {
  get selected(): UnitModel {
    return this.$store.state.units.item
  }

  private created() {
    // fetch widget settings and calc
    this.$store.dispatch('widgets/getAll')
    this.$store.dispatch('units/getAllFloors', this.selected)
  }
}
